import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CourseProgramCards = ({
  programs = [],
  basePath = "/course",
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  // Map program headings to actual routes defined in App.js
  const headingToRoute = {
    "Information Technology": "/course/information-technology",
    "Cybersecurity": "/course/cyber-security",
    "Business Administration": "/course/business-administration",
    "Travel and Tourism": "/course/travel-tourism-management",
  };

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mt-8 mb-32 justify-center items-start">
      {programs.map((program, index) => {
        return (
          <div
            key={program.id}
            className={`
            border rounded-xl overflow-hidden shadow-lg w-full mx-auto max-w-[340px]
            transform transition-all duration-700 ease-out bg-white
            hover:shadow-2xl hover:-translate-y-3 hover:scale-[1.02]
            group
            ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-8"
            }
          `}
            style={{
              transitionDelay: `${index * 150}ms`,
            }}
          >
            <div className="relative overflow-hidden">
              <img
                src={program.image}
                alt={program.heading}
                className="w-full h-[220px] object-cover transition-transform duration-500 ease-out group-hover:scale-110"
              />
              <span className="block border-b-4 border-gold w-full transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out origin-left"></span>
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300 ease-out"></div>
            </div>
            <div className="p-6 text-left">
              <h3 className="font-bold text-[1.25rem] mb-2 text-custom-pink tracking-normal">
                {program.heading}
              </h3>
              <p className="mb-4 text-[0.95rem] text-gray-800">
                {program.introduction}
              </p>
              <div className="flex items-center gap-3">
                <button
                  onClick={() => {
                    const slug = program.heading
                      .toLowerCase()
                      .replace(/[^a-z0-9]+/g, "-")
                      .replace(/(^-|-$)/g, "");
                    const target = headingToRoute[program.heading] || `${basePath}/${slug}`;
                    navigate(target);
                  }}
                  className="w-full bg-custom-pink text-white px-4 py-2 rounded-full hover:bg-purple-600 transition-colors duration-300 font-semibold"
                >
                  Learn More
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CourseProgramCards;

